// extracted by mini-css-extract-plugin
export var modal = "_st-0";
export var table = "_st-1";